import { DeckGL } from "@deck.gl/react";
import { globeView, INITIAL_VIEW_STATE, createLayers } from "../features/deckGlMapConfig";
import React from "react";

interface DeckGlobeMapProps {
    layerConfigs: Array<{
        imageIndex: number;
        bitmapImages: (string | HTMLImageElement)[];
        show: boolean;
        transparency: number;
    }>;
    viewState?: any;
    onViewStateChange?: (params: any) => void;
}

export const DeckGlobeMap: React.FC<DeckGlobeMapProps> = ({ layerConfigs, viewState, onViewStateChange }) => {
    const layers = React.useMemo(() => createLayers(layerConfigs), [layerConfigs]);
    return (
        <DeckGL
            style={{ width: "100%", height: "100%", background: "transparent" }}
            // @ts-expect-error: 'cull' is not a known property on Parameters, but this works at runtime.
            parameters={{ cull: true }}
            views={[globeView]}
            initialViewState={INITIAL_VIEW_STATE}
            viewState={viewState}
            onViewStateChange={onViewStateChange}
            controller={true}
            layers={layers}
        />
    );
}; 